/**
 * PhantomTargetNode.tsx - Invisible target node for phantom edges
 *
 * This node exists purely as an anchor point for the phantom "Add Path" edge.
 * It renders nothing visible but provides React Flow with a valid node to
 * calculate edge endpoints.
 */

import { Handle, Position, type NodeProps, type Node } from '@xyflow/react';
import type { BaseNodeData } from '../types';

type PhantomTargetNodeType = Node<BaseNodeData>;

export function PhantomTargetNode(_props: NodeProps<PhantomTargetNodeType>) {
	// Render invisible handles for edge connection
	return (
		<div style={{ width: 1, height: 1, opacity: 0 }}>
			<Handle type='target' position={Position.Left} style={{ opacity: 0, pointerEvents: 'none' }} />
			<Handle type='source' position={Position.Right} style={{ opacity: 0, pointerEvents: 'none' }} />
		</div>
	);
}
